import { FC } from 'react'
import Landing, { Config } from 'components/Landing'
import { useTranslation } from 'react-i18next'
import { useCrsLinks, useCcsLinks } from '@client-hub/shared/react/hooks/links'

const RootLanding: FC = () => {
  const { t } = useTranslation()
  const config: Config = [
    {
      title: t('routes.landing.adminAndReporting'),
      cards: useCrsLinks(),
    },
    {
      title: t('routes.landing.configuration'),
      cards: useCcsLinks(),
    },
  ]

  return <Landing config={config} title={t('routes.landing.clientHub')} />
}

export default RootLanding
